module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": "water-type",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": "!water-type_opt2"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2 && tap",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!water-type_opt2 && tap",
				"main-faucet"
			],
			"options": [
				{
					"_comment": "L",
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!water-type_opt2 && tap_opt1",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"_comment": "U",
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"_comment": "C",
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && !tap_opt0",
						"water-type_opt1 && tap_opt0 && !location_opt1",
						"water-type_opt2 && tap_opt0",
						"tap_opt1",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"location_opt1 && !water-type_opt2 && tap_opt0",
				"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": "abc",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout_opt0 && !main-faucet_opt0",
				"duo-spout_opt1 && !main-faucet_opt0",
				"location_opt0 && duo-spout_opt2 && main_faucet_opt1",
				"mono-spout_opt1",
				"duo-spout_opt2 && !main-faucet_opt0"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"location_opt0",
						"!water-type_opt0",
						"tap_opt1"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!water-type_opt1 && finish",
				"main-faucet_opt0 && duo-spout",
				"location_opt0 && water-type_opt0 && tap_opt0"
			],
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "abc",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};


//////////////////
// WEBPACK FOOTER
// ./src/data/water_questions_fr_be.json
// module id = 894
// module chunks = 0